import Swal from 'sweetalert2';

import { blackberry } from 'lib/css/colors';

const SwalDialog = (type, message, title = 'Success', position = 'top-middle', callback) => {
  Swal.fire({
    position: position,
    icon: type,
    text: message,
    title: title,
    showConfirmButton: true,
  }).then(() => callback && callback());
};

const areYouSure = (action, text, title) => {
  Swal.fire({
    title: title || 'Are you sure?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    text,
    customClass: {
      cancelButton: 'order-1',
      confirmButton: 'order-2',
    },
  }).then(result => {
    if (result.value) {
      action();
    }
  });
};

/**
 * Confirmation dialog that supports rich HTML content.
 * Prefer this over areYouSure when the message needs formatting (lists, bold, etc.).
 *
 * @param {Function} action - Callback to invoke when the user confirms.
 * @param {string}   html   - HTML string rendered inside the dialog body.
 * @param {string}   title  - Dialog title.
 * @param {string}   [confirmButtonText='Yes'] - Label for the confirm button.
 */
const confirmRichAction = (action, html, title, confirmButtonText = 'Yes') => {
  Swal.fire({
    icon: 'warning',
    title: title || 'Are you sure?',
    html,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText: 'Cancel',
    confirmButtonColor: blackberry,
    customClass: {
      cancelButton: 'order-1',
      confirmButton: 'order-2',
    },
  }).then(result => {
    if (result.isConfirmed) {
      action();
    }
  });
};

const SwalToast = (type, message, position) => {
  Swal.fire({
    toast: true,
    title:
      '<div style="display: flex; align-items: center;"><i class="icon"></i>' + message + '</div>',
    icon: type,
    position: position ? position : 'top-end',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    didOpen: toast => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
  });
};

const exportFileSuccessSwal = (message = 'The export csv file will be generated in a while.') => {
  Swal.fire({
    icon: 'success',
    html: `
      <div>
        ${message}
        You can download the generated file from
        <a
          href="/file-exports"
          rel="noopener noreferrer"
          target="_blank"
        >
          File Exports Page
        </a>
      </div>`,
    title: 'Success',
    position: 'center',
  });
};

/** Same as exportFileSuccessSwal but inserts a line break after the message. */
const exportFileSuccessSwalWithBreak = (
  message = 'The export csv file will be generated in a while.',
) => {
  Swal.fire({
    icon: 'success',
    html: `
    <div>
      ${message}
      <br />
      You can download the generated file from
      <a
        href="/file-exports"
        rel="noopener noreferrer"
        target="_blank"
      >
        File Exports Page
      </a>
    </div>`,
    title: 'Success',
    position: 'center',
  });
};

const exportFileErrorSwal = (message = 'An error occurred while trying to export the file') => {
  Swal.fire({
    icon: 'error',
    title: 'Error',
    text: message,
  });
};

/** @deprecated Use exportFileSuccessSwal (same function). */
const exportSuccessDialog = exportFileSuccessSwal;

export default SwalDialog;
export {
  areYouSure,
  confirmRichAction,
  SwalToast,
  exportFileErrorSwal,
  exportFileSuccessSwal,
  exportFileSuccessSwalWithBreak,
  exportSuccessDialog,
};
